export const AwsConfigAuth = {
  Auth: {
    region: "eu-west-1",
    userPoolId: "eu-west-1_xqdyN2if5",
    userPoolWebClientId: "3d8fndju02ck04o4kn10bahnf0",
    mandatorySignIn: false,
    cookieStorage: {
    domain: "wallboards.nova.dttsynergy.com",
    path: "/",
    expires: 365,
    sameSite: "strict",
    secure: false,
    },
    authenticationFlowType: "USER_SRP_AUTH",
    oauth: {
    domain: "synergy.auth.eu-west-1.amazoncognito.com",
    scope: [
    "phone",
    "email",
    "profile",
    "openid",
    "aws.cognito.signin.user.admin",
    ],
    redirectSignIn: "https://wallboards.nova.dttsynergy.com/",//process.env.NODE_ENV === 'production' ? `${process.env.REACT_APP_DOMINIO_PRODUCTION_URL}` : `${process.env.REACT_APP_DOMINIO_DEVELOPMENT_URL}`,//"https://wallboards.nova.dttsynergy.com/",
    redirectSignOut: "https://wallboards.nova.dttsynergy.com/",//process.env.NODE_ENV === 'production' ? `${process.env.REACT_APP_DOMINIO_PRODUCTION_URL}` : `${process.env.REACT_APP_DOMINIO_DEVELOPMENT_URL}`,
    responseType: "token", // or 'token', note that REFRESH token will only be generated when the responseType is code
    },
  },
};